import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Notifications Components
import { AlertComponent } from './alert/alert.component';
import { StorerRequestComponent } from './storer-request/storer-request.component';
import { GenericNotificationComponent } from './generic-notification/generic-notification.component';
import { AuthorizePurchaseOrderComponent } from './authorize-purchase-order/authorize-purchase-order.component';
import { AuthorizeWorkOrderComponent } from './authorize-work-order/authorize-work-order.component';
import { MaintenanceExecutionComponent } from './maintenance-execution/maintenance-execution.component';
import { MaintenanceRequestNotificationComponent } from './maintenance-request-notification/maintenance-request-notification.component';
import { FuelRequestsNotificationComponent } from './fuel-requests-notification/fuel-requests-notification.component';
import { FuelOrderNotificationComponent } from './fuel-order-notification/fuel-order-notification.component';
import { AttachedInformationComponent } from './attached-information/attached-information.component';

const NotificationsComponents = [
  AlertComponent,
  StorerRequestComponent,
  GenericNotificationComponent,
  AuthorizePurchaseOrderComponent,
  AuthorizeWorkOrderComponent,
  MaintenanceExecutionComponent,
  MaintenanceRequestNotificationComponent,
  FuelRequestsNotificationComponent,
  FuelOrderNotificationComponent,
  AttachedInformationComponent
];

@NgModule({
  declarations: NotificationsComponents,
  imports: [SharedModule],
  exports: NotificationsComponents
})
export class NotificationsModule { }
